import { render, staticRenderFns } from "./ResetProPasswordView.vue?vue&type=template&id=641740f5"
import script from "./ResetProPasswordView.vue?vue&type=script&lang=js"
export * from "./ResetProPasswordView.vue?vue&type=script&lang=js"
import style0 from "./ResetProPasswordView.vue?vue&type=style&index=0&id=641740f5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports